/* global propel, gtag */

import { __ } from '@wordpress/i18n';

const cards = document.querySelectorAll('.coupon-card');

let iframe = null;
let action = '';
let currentActionCouponId = '';

cards.forEach(function (card) {
	const detailsButton = card.querySelector('.coupon-card__details-button');

	card.addEventListener('click', function (event) {
		const target = event.target;

		if (target.closest('button') || target.closest('a')) {
			return;
		}

		if (detailsButton) {
			detailsButton.click();
		}
	});

	if (detailsButton) {
		const block = card.closest('.acf-block');

		if (block) {
			const openButton = block.querySelector('[href*="#open-coupon"]');

			if (openButton) {
				openButton.addEventListener('click', (e) => {
					e.preventDefault();

					detailsButton.click();
				});
			}
		}
	}
});

const printCoupon = (e) => {
	e.preventDefault();
	const button = e.currentTarget;
	const url = button?.dataset?.url ?? '';

	if (!url) {
		return;
	}

	if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
		window.open(url, '_blank');

		return;
	}

	button.classList.add('coupon-card__button--loading');

	if (!iframe) {
		iframe = document.createElement('iframe');
		iframe.style.display = 'none';
		document.body.appendChild(iframe);
	}

	iframe.src = url;
	iframe.onload = () => {
		button.classList.remove('coupon-card__button--loading');
		iframe.onload = null;
	};
};

const textOrEmailCoupon = (e, thisAction) => {
	e.preventDefault();
	currentActionCouponId = e?.currentTarget?.dataset?.couponId ?? '';
	const button = e.currentTarget;
	const buttonAction = button?.dataset?.action ?? 'text';

	const lightbox = button.closest('.coupon-card-lightbox');

	if (lightbox) {
		displayForm(lightbox, buttonAction);
	} else {
		action = thisAction;
		const detailsButton = button
			?.closest('.coupon-card')
			?.querySelector('.coupon-card__details-button');

		if (detailsButton) {
			detailsButton.click();
		}
	}
};

const initializeCouponButtons = () => {
	const buttons = document.querySelectorAll(
		'.coupon-card__button:not(.coupon-card__button--initialized)'
	);

	buttons.forEach((button) => {
		button.classList.add('coupon-card__button--initialized');

		if (button.classList.contains('coupon-card__button--print')) {
			button.addEventListener('click', printCoupon);
		} else if (button.classList.contains('coupon-card__button--email')) {
			button.addEventListener('click', (e) =>
				textOrEmailCoupon(e, 'email')
			);
		} else if (button.classList.contains('coupon-card__button--text')) {
			button.addEventListener('click', (e) =>
				textOrEmailCoupon(e, 'text')
			);
		}
	});
};

const initializeCouponForms = () => {
	const forms = document.querySelectorAll(
		'.coupon-card-lightbox__form:not(.coupon-card-lightbox__form--initialized)'
	);

	forms.forEach((form) => {
		form.classList.add('coupon-card-lightbox__form--initialized');

		renderInvisibleRecaptcha(form);

		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			const formContent = form.closest('.coupon-card-lightbox__content');
			const formId = form.dataset.formId;
			const formType = form.dataset.formType;
			const couponCode = form.dataset.couponCode || '';
			const locationCode = form.dataset.locationCode || '';
			const url = `${propel.siteUrl}/wp-json/propel/v1/coupon-request/${formId}/`;
			form.classList.add('coupon-card-lightbox__form--loading');

			const formData = new FormData(form);
			const data = {
				form_type: formType,
			};

			formData.forEach((value, key) => {
				data[key] = value;
			});

			const params = new URLSearchParams(window.location.search);
			const utmFields = [
				{ id: 9000000, key: 'utm_source' },
				{ id: 9000001, key: 'utm_medium' },
				{ id: 9000002, key: 'utm_campaign' },
				{ id: 9000003, key: 'utm_term' },
				{ id: 9000004, key: 'utm_content' },
			];

			utmFields.forEach(({ key, id }) => {
				const value = params.get(key);

				if (value) {
					data[`input_${id}`] = value;
				}
			});

			data.input_5000001 = window.location.href;

			const messageElem = form.querySelector(
				'.coupon-card-lightbox__form-message'
			);

			messageElem.textContent = '';
			messageElem.classList.remove(
				'coupon-card-lightbox__form-message--success',
				'coupon-card-lightbox__form-message--error'
			);

			if (!window.grecaptcha || undefined === form.recaptchaWidgetId) {
				form.classList.add('coupon-card-lightbox__form--loading');

				const start = Date.now();
				while (
					(!window.grecaptcha ||
						form.recaptchaWidgetId === undefined) &&
					Date.now() - start < 5000
				) {
					await new Promise((r) => setTimeout(r, 100));
				}

				form.classList.remove('coupon-card-lightbox__form--loading');
			}

			if (!window.grecaptcha || undefined === form.recaptchaWidgetId) {
				displayFormMessage(
					form,
					formContent,
					__('Error loading reCAPTCHA. Please try again.', 'propel'),
					messageElem,
					'error'
				);

				return;
			}

			let attempts = 0;
			const maxAttempts = 2;
			let success = false;

			while (attempts < maxAttempts && !success) {
				attempts++;

				try {
					if (form._recaptchaToken) {
						window.grecaptcha.reset(form.recaptchaWidgetId);
					}

					const token = await executeRecaptcha(form);

					data['g-recaptcha-response'] = token;

					const response = await fetch(url, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
						},
						body: JSON.stringify(data),
					});

					const result = await response.json();

					displayFormMessage(
						form,
						formContent,
						result.message ||
							__(
								'An error occurred sending your coupon. Please try again.',
								'propel'
							),
						messageElem,
						result.status === 'success' ? 'success' : 'error'
					);

					if ('success' === result.status) {
						success = true;

						if ('function' === typeof gtag && couponCode) {
							let eventLabel = `${couponCode}`;

							if (locationCode) {
								eventLabel += ` - Store: ${locationCode}`;
							}

							if ('email' === formType) {
								gtag('event', 'Email Coupon Requested', {
									event_category: 'Coupons',
									event_label: `${eventLabel}`,
								});
							} else if ('text' === formType) {
								gtag('event', 'SMS Coupon Requested', {
									event_category: 'Coupons',
									event_label: `${eventLabel}`,
								});
							}
						}
					}
				} catch (error) {
					if (attempts >= maxAttempts) {
						displayFormMessage(
							form,
							formContent,
							__(
								'Error verifying reCAPTCHA. Please try again.',
								'propel'
							),
							messageElem,
							'error'
						);
					}
				}
			}
		});
	});
};

const displayFormMessage = (
	form,
	formContent,
	message,
	messageElem,
	status
) => {
	messageElem.textContent = message;
	messageElem.classList.remove(
		'coupon-card-lightbox__form-message--success',
		'coupon-card-lightbox__form-message--error'
	);

	form.classList.remove('coupon-card-lightbox__form--loading');
	messageElem.classList.add(`coupon-card-lightbox__form-message--${status}`);

	if (formContent) {
		formContent.scrollTo({
			top: formContent.scrollHeight,
			behavior: 'smooth',
		});
	}
};

const lightboxOpened = () => {
	initializeCouponButtons();
	initializeCouponForms();

	const lightboxes = document.querySelectorAll(`.coupon-card-lightbox`);

	lightboxes.forEach((lightbox) => {
		lightbox.classList.remove(
			'coupon-card-lightbox--email',
			'coupon-card-lightbox--text'
		);
	});

	if ('email' === action || 'text' === action) {
		const lightbox = document.querySelector(
			`.coupon-card-lightbox[data-id="${currentActionCouponId}"]`
		);

		if (lightbox) {
			displayForm(lightbox, action);
		}
	}

	action = '';
	currentActionCouponId = '';
};

const loadRecaptcha = () => {
	return new Promise((resolve) => {
		if (window.grecaptcha) {
			resolve();
			return;
		}

		if (document.getElementById('recaptcha-script')) {
			const check = setInterval(() => {
				if (window.grecaptcha) {
					clearInterval(check);
					resolve();
				}
			}, 50);
			return;
		}

		const script = document.createElement('script');
		script.id = 'recaptcha-script';
		script.src = 'https://www.google.com/recaptcha/api.js';
		script.onload = () => resolve();
		document.head.appendChild(script);
	});
};

const renderInvisibleRecaptcha = async (form) => {
	await loadRecaptcha();

	await new Promise((resolve) => {
		window.grecaptcha.ready(() => resolve());
	});

	let container = form.querySelector('.recaptcha-container');

	if (!container) {
		container = document.createElement('div');
		container.className = 'recaptcha-container';

		form.appendChild(container);
	}

	const widgetId = window.grecaptcha.render(container, {
		sitekey: propel.recaptchaSiteKey,
		size: 'invisible',
		badge: 'inline',
		callback(token) {
			form._recaptchaToken = token;
		},
	});

	form.recaptchaWidgetId = widgetId;

	return widgetId;
};

const executeRecaptcha = (form) => {
	return new Promise((resolve, reject) => {
		try {
			form._recaptchaToken = null;

			window.grecaptcha.execute(form.recaptchaWidgetId);

			const checkToken = setInterval(() => {
				if (form._recaptchaToken) {
					clearInterval(checkToken);
					resolve(form._recaptchaToken);
				}
			}, 50);
		} catch (err) {
			reject(err);
		}
	});
};

const displayForm = (lightbox, thisAction) => {
	lightbox.classList.remove(
		'coupon-card-lightbox--email',
		'coupon-card-lightbox--text'
	);
	lightbox.classList.add(`coupon-card-lightbox--${thisAction}`);
};

if (
	document.body.classList.contains('single-coupon') &&
	new URLSearchParams(window.location.search).get('print')
) {
	if ('function' === typeof gtag && document.body?.dataset?.couponCode) {
		let eventLabel = document.body.dataset.couponCode;

		if (document.body?.dataset?.locationCode) {
			eventLabel += ` - Store: ${document.body.dataset.locationCode}`;
		}

		gtag('event', 'Coupon Printed', {
			event_category: 'Coupons',
			event_label: `${eventLabel}`,
		});
	}

	const closeButton = document.querySelector(
		'.coupon-card-lightbox__close-button'
	);

	if (closeButton) {
		closeButton.addEventListener('click', () => {
			window.close();
		});
	}

	document.querySelectorAll('img').forEach((img) => {
		img.loading = 'eager';
	});

	window.addEventListener('load', () => {
		requestAnimationFrame(() => {
			setTimeout(() => {
				window.onafterprint = function () {
					window.close();
				};

				window.print();
			}, 250);
		});
	});
}

initializeCouponButtons();
initializeCouponForms();

window.addEventListener('propel-lightbox-opened', lightboxOpened);
